<style lang='less' scoped>
.student-data {
  width: auto;
  height: 100%;
  padding: 18px;
  box-sizing: border-box;
  background: #f3f3f3;
  position: relative;
  .header {
    position: relative;
    width: auto;
    height: auto;
    display: flex;
    background: #fff;
    padding: 10px 10px;
    box-sizing: border-box;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    .common-style {
      margin-left: 10px;
      box-sizing: border-box;
      display: flex;
      .empty-box {
        width: 10px;
      }
    }
    .header-search {
      position: absolute;
      right: 10px;
      margin-left: 10px;
      box-sizing: border-box;
      display: flex;
      .empty-box {
        width: 12px;
      }
    }
  }
  .content {
    position: relative;
    width: 100%;
    height: auto;
    background: #fff;
    padding: 10px 10px;
  }
  .footer {
    position: relative;
    height: 144px;
    width: 100%;
    background: #fff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: 24px 10px;
    box-sizing: border-box;
  }
  .create-new {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    height: 600px;
    padding: 0 16px;
    box-sizing: border-box;
    z-index: 9999;
    .header {
      width: 100%;
      height: 48px;
      display: flex;
      line-height: 36px;
      font-weight: 600;
      .back {
        width: 72px;
        height: 48px;
      }
      .message {
        width: 98px;
        height: 48px;
        text-align: center;
      }
    }
    .content {
      width: 100%;
      height: 300px;
      margin-top: 20px;
      padding: 10px 10px;
      box-sizing: border-box;
      .student-list {
        width: 100%;
        padding: 8px 12px;
        box-sizing: border-box;
        display: flex;
        background: #fff;
        border-top: 1px #c9c9c9 solid;
        .box {
          width: 220px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          .sure {
            background: #bee9ff;
            border: 1px #1c7ef7 solid;
            color: #1c7ef7;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.choose-date {
  .ivu-input {
    height: 40px !important;
  }
  .ivu-select-input {
    height: 40px !important;
  }
}
.choose-type {
  .ivu-select-input {
    height: 40px !important;
  }
  .ivu-select-selection {
    height: 40px !important;
  }
}
.choose-status {
  .ivu-select-input {
    height: 40px !important;
  }
}
</style>
<template>
  <div class="student-data">
    <div v-show="mainPage">
      <div class="header">
        <el-cascader
          placeholder="输入机构名称或班级名称"
          v-model="valueClass"
          :options="groupList"
          style="width:300px"
          filterable
        />
        <div class="common-style">
          <DatePicker
            class="choose-date"
            :value="dateTime"
            format="yyyy/MM/dd"
            type="daterange"
            placement="bottom-end"
            placeholder="选择起止日期"
            style="width: 280px"
            :options="shortcutsOption"
            @on-change="SetNewAvgDate"
          />
        </div>
        <div class="common-style">
          <Select
            class="choose-type"
            v-model="homeworkType"
            placeholder="请选择作业类型"
            filterable
            style="width:240px"
          >
            <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </div>
        <div class="common-style">
          <Select
            class="choose-status"
            v-model="homeworkStatus"
            placeholder="请选择作业状态"
            filterable
            multiple
            style="width:240px;"
          >
            <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </div>
        <div class="common-style">
          <Button
            style="height: 40px"
            @click="SearchStudentInfo"
            type="primary"
            icon="ios-search"
          >搜索</Button>
          <div class="empty-box"/>
          <Button @click="ClearAll" style="height: 40px" type="primary">重置</Button>
        </div>
      </div>
      <div class="content">
        <i-table border :columns="homeworkColumns" :data="studentData"/>
      </div>
      <div class="footer">
        <Page
          :total="count"
          :page-size="pageSize"
          :page-size-opts="[10,20]"
          show-total
          @on-change="ChangePage"
          @on-page-size-change="ChangePageSize"
          show-elevator
          show-sizer
        />
      </div>
    </div>
    <div v-show="studentInfo">
      <div class="create-new">
        <div class="header">
          <Button @click="Reback" type="primary" style="height: 36px;">
            <Icon type="ios-arrow-back" />返回
          </Button>
          <div class="message">更多数据</div>
        </div>
        <div class="content">
          <i-table border :columns="studentColumns" :data="studentMessage"/>
        </div>
      </div>
    </div>
    <div v-show="homeworkInfo">
      <div class="create-new">
        <div class="header">
          <Button @click="Reback" type="primary" style="height: 36px;">
            <Icon type="ios-arrow-back" />返回
          </Button>
          <div class="message">更多数据</div>
        </div>
        <div class="content">
          <div class="student-list">
            <div class="box">序号</div>
            <div class="box">内容类型</div>
            <div class="box">内容名称</div>
          </div>
          <div class="student-list" v-for="(item,index) in taskMessage" :key="index">
            <div class="box">{{index+1}}</div>
            <div class="box">
              <i-button v-show="item.task_type==1" type="primary" class="sure">跟读</i-button>
              <i-button v-show="item.task_type==2" type="primary" class="sure">配音</i-button>
              <i-button v-show="item.task_type==3" type="primary" class="sure">点读</i-button>
            </div>
            <div class="box">{{item.task_content}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import schoolApi from '@/lib/api/school'
import analysisApi from '@/lib/api/analysis'
const TASK_TYPE = ['跟读作业', '配音作业', '点读作业']
const DAT_MINI_SECOND = 3600 * 1000 * 24
// const TASK_STATUS = ['已结束','进行中']
export default {
  name: '',
  data() {
    return {
      valueClass: [], // 机构班级搜索
      mainPage: true, // 主页面显示与否
      studentInfo: false, // 查看学生信息
      homeworkInfo: false, // 作业详情
      studentMessage: [], // 查看学生
      taskMessage: [], // 查看作业
      self: this,
      classList: [], // 班级列表
      checkClass: '', // 选择的班级
      dateTime: [], // 起止日期
      studentList: [], // 学生列表
      homeworkType: '', // 作业类型
      homeworkStatus: [], // 作业状态
      groupList: [], // 机构-班级列表查询
      shortcutsOption: {
        shortcuts: [
          {
            text: '今天',
            value() {
              const end = new Date()
              const start = new Date()
              return [start, end]
            }
          },
          {
            text: '昨天',
            value() {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND)
              end.setTime(end.getTime() - DAT_MINI_SECOND)
              return [start, end]
            }
          },
          {
            text: '过去7天',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND * 7)
              return [start, end]
            }
          },
          {
            text: '过去30天',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND * 30)
              return [start, end]
            }
          }
          // {
          //   text: '过去60天',
          //   value() {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - DAT_MINI_SECOND * 60);
          //     return [start, end];
          //   }
          // },
          // {
          //   text: '过去90天',
          //   value() {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - DAT_MINI_SECOND * 90);
          //     return [start, end];
          //   }
          // }
        ]
      },
      cityList: [
        {
          value: '1',
          label: '进行中'
        },
        {
          value: '2',
          label: '已截止'
        }
      ],
      typeList: [
        {
          value: '1',
          label: '跟读作业'
        },
        {
          value: '2',
          label: '配音作业'
        },
        {
          value: '3',
          label: '点读作业'
        }
      ],
      start: 0,
      pageSize: 10,
      count: 0, // 总条数
      showList: [], // 展示列表
      studentData: [], // 学生数据
      studentColumns: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '学生姓名',
          key: 'name'
        },
        {
          title: '完成时间',
          key: 'complete_time'
        },
        {
          title: '作业平均分',
          key: 'avg_score'
        }
      ],
      homeworkColumns: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '所属学校班级',
          key: 'className'
        },
        {
          title: '布置时间',
          key: 'creatTime'
        },
        {
          title: '作业类型',
          key: 'taskType'
        },
        {
          title: '作业状态',
          key: 'taskStatus'
        },
        {
          title: '作业完成率',
          key: 'taskAchieve'
        },
        {
          title: '作业平均分',
          key: 'taskAvgScore'
        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const editBtn = h('i-button', {
              on: {
                click: () => {
                  this.CheckStudent(params.row.workId, params.row.type)
                }
              },
              props: {
                type: 'primary'
              }
            }, '查看学生')
            const emptyBox = h('div', {
              style: {
                width: '16px'
              }
            })
            const delBtn = h('i-button', {
              on: {
                click: () => {
                  this.CheckHomework(params.row.workId, params.row.type)
                }
              },
              props: {
                type: 'primary'
              }
            }, '查看内容')
            return h('div', {
              style: {
                display: 'flex'
              }
            }, [editBtn, emptyBox, delBtn])
          }
        }
      ]
    }
  },
  created() {
    this.GetClass()
    this.GetGroupData()
    this.SearchStudentInfo()
  },
  methods: {
    SetNewAvgDate(format) {
      this.dateTime = format
    },
    // 机构班级层级
    GetGroupData() {
      analysisApi.GetGroupAndClass().then(result => {
        const data = result.data
        console.log('分组', data)
        this.groupList = [{
          value: 0,
          label: '全部',
          children: [{
            value: 0,
            label: '全部'
          }]
        }, ...data.map(item => {
          return {
            value: item.institution_id,
            label: item.name,
            children: [{
              value: 0,
              label: '全部'
            }, ...item.groups.map(sItem => {
              return {
                value: sItem.id,
                label: sItem.name
              }
            })]
          }
        })]
      })
    },
    // 重置
    ClearAll() {
      this.checkClass = ''
      this.dateTime = []
      this.homeworkType = ''
      this.homeworkStatus = []
      this.valueClass = []
      this.SearchStudentInfo()
    },
    // 查看学生
    CheckStudent(id, type) {
      this.mainPage = false
      this.studentInfo = true
      analysisApi
        .StudentCompleteData({
          id: id,
          type: type
        })
        .then(res => {
          const studentData = res
          this.studentMessage = studentData.data // 所有数据
        })
    },
    // 查看作业
    CheckHomework(id, type) {
      this.mainPage = false
      this.homeworkInfo = true
      analysisApi
        .TaskData({
          id: id,
          type: type
        })
        .then(res => {
          const taskData = res
          this.taskMessage = taskData.data // 所有作业数据
        })
    },
    // 返回按钮
    Reback() {
      this.studentInfo = false
      this.homeworkInfo = false
      this.mainPage = true
    },
    // 搜索学生作业
    SearchStudentInfo() {
      analysisApi
        .SearchHomework({
          organId: this.valueClass[0],
          groupId: this.valueClass[1],
          start: this.start,
          rows: this.pageSize,
          startTime: this.dateTime.length == 0 ? '' : new Date(this.dateTime[0]).format('yyyy-MM-dd'),
          endTime: this.dateTime.length == 0 ? '' : new Date(this.dateTime[1]).format('yyyy-MM-dd'),
          taskType: this.homeworkType,
          taskStatus: this.homeworkStatus.join(',')
        })
        .then(res => {
          const data = res.data
          this.count = data.count // 总条数
          this.showList = res.data.list
          this.studentData = data.list.map((item) => {
            if (new Date() > new Date(parseInt(item.end_time) * 1000)) {
              item.taskStatus = '已截止'
            } else {
              item.taskStatus = '进行中'
            }
            return {
              id: item.id,
              className: item.class_name,
              creatTime: item.date_time,
              taskType: TASK_TYPE[item.type - 1],
              taskStatus: item.taskStatus,
              taskAchieve: parseFloat(item.complete_rate * 100).toFixed(1) + '%',
              rate: parseFloat(item.taskAchieve).toFixed(1) + '%',
              taskAvgScore: parseFloat(item.avg_score).toFixed(1),
              workId: item.work_id,
              type: item.type,
              endTime: new Date(parseInt(item.end_time) * 1000).format('yyyy-MM-dd HH:mm:ss')
            }
          })
          console.log(this.studentData)
        })
    },
    ChangePage(index) {
      this.start = (index - 1) * this.pageSize
      this.SearchStudentInfo()
    },
    ChangePageSize(pageSize) {
      this.pageSize = pageSize
      this.SearchStudentInfo()
    },
    // 获取班级列表
    GetClass() {
      schoolApi
        .GetClassList({
          keyword: this.userId,
          start: this.start,
          rows: this.pageSize
        })
        .then(res => {
          this.classList = res.data.list // 所有数据
        })
    },
    // 获取学生列表
    GetStudentInfo() {
      schoolApi
        .GetStudentList({
          keyword: this.userId,
          start: this.start,
          rows: this.pageSize
        })
        .then(res => {
          const studentData = res
          this.studentList = studentData.data.list // 所有数据
        })
    }
  }
}
</script>
